import React from 'react';
import Icon from '../atoms/Icon';

function StarSquareIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <g 
        fill='currentColor' 
        fillRule='nonzero'
      >
        <path d='M15.8182 12.2591L16.4773 13.7091L17.1364 15.1591L18.7182 15.2909L20.3 15.4227L19.1136 16.4773L17.9273 17.5318L18.1909 18.9818L18.5864 20.5636L17.1364 19.7727L15.8182 18.9818L14.5 19.7727L13.1818 20.5636L13.5773 18.9818L13.8409 17.5318L12.6545 16.4773L11.4682 15.4227L13.05 15.2909L14.6318 15.1591L15.2909 13.7091L15.8182 12.2591ZM15.8182 5.79999L12.7864 12.6545L5.27273 13.4454L10.9409 18.4545L9.35909 25.8364L15.8182 22.0136L22.2773 25.8364L20.6955 18.4545L26.3636 13.4454L18.85 12.6545L15.8182 5.79999Z'/>
      </g>

      <g 
        fill='none' 
        stroke='currentColor'
        stroke-width='2.23077'
        stroke-miterlimit='10'
      >
        <path d='M30.3182 1.31818H1.31818V30.3182H30.3182V1.31818Z'/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(StarSquareIcon);
